import { render, staticRenderFns } from "./BInputNumber.vue?vue&type=template&id=f4512df6"
import script from "./BInputNumber.vue?vue&type=script&lang=ts"
export * from "./BInputNumber.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports